import React from "react";
import { Box, Stack } from "@mui/material";
import { ParlorDetailProps } from "../../../types";
import { ColorSystemProps } from "../../../constants";

export function HeroPills({
  defaultParlor,
  mainColor,
}: {
  defaultParlor: ParlorDetailProps;
  mainColor: ColorSystemProps;
}) {
  const binsos = defaultParlor.binsos || [];
  const minPy = binsos.length ? Math.min(...binsos.map((b) => b.pyeong || 0)) : 0;
  const maxPy = binsos.length ? Math.max(...binsos.map((b) => b.pyeong || 0)) : 0;

  const pills: { label: string; primary?: boolean }[] = [
    { label: "e하늘 공공 데이터 기반", primary: true },
    ...(defaultParlor.managed_type ? [{ label: `${defaultParlor.managed_type} 장례식장` }] : []),
    ...(binsos.length ? [{ label: `빈소 ${binsos.length}실 · ${minPy}~${maxPy}평` }] : []),
    { label: "24시간 운영" },
    { label: "고이 상담 데이터 보정" },
  ];

  return (
    <Stack
      component="ul"
      direction="row"
      flexWrap="wrap"
      gap="8px"
      style={{
        marginTop: "40px",
        paddingTop: "24px",
        borderTop: "1px solid #dedede",
        listStyle: "none",
        padding: "24px 0 0 0",
      }}
    >
      {pills.map((pill, i) => (
        <Box
          key={i}
          component="li"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 14px",
            borderRadius: "999px",
            fontSize: "12px",
            fontWeight: pill.primary ? 700 : 600,
            color: pill.primary ? mainColor.c500 : "#535353",
            background: pill.primary ? mainColor.c100 : "#fff",
            border: `1px solid ${pill.primary ? mainColor.c200 : "#dedede"}`,
          }}
        >
          {pill.label}
        </Box>
      ))}
    </Stack>
  );
}
